import React from "react";

interface InfoRowScrollProps {
  monthGridTemplateColumns: string;
  registerMonthScroller: (key: string) => (node: HTMLDivElement | null) => void;
  onMonthScroll: (sourceKey: string, scrollLeft: number) => void;
}

interface KochGuidanceInfoRowProps extends InfoRowScrollProps {}

export const KochGuidanceInfoRow: React.FC<KochGuidanceInfoRowProps> = ({
  monthGridTemplateColumns,
  registerMonthScroller,
  onMonthScroll,
}) => (
  <div className="dom-pane-row dom-pane-row--info">
    <div className="dom-pane-left dom-pane-left--info">
      <span className="dom-info-tag">KOCH GUIDANCE</span>
      <span className="dom-info-text">
        Asset owners set Koch guidance. Updates are visible to everyone.
      </span>
    </div>
    <div
      ref={registerMonthScroller("info-koch")}
      className="dom-pane-center-scroll dom-pane-center-scroll--info"
      onScroll={(event) => onMonthScroll("info-koch", event.currentTarget.scrollLeft)}
    >
      <div
        className="dom-pane-month-grid"
        style={{ gridTemplateColumns: monthGridTemplateColumns }}
      >
        <div className="dom-pane-info-center-cell" />
      </div>
    </div>
    <div className="dom-pane-right dom-pane-right--info" />
  </div>
);

interface CompetitorIndicationsInfoRowProps extends InfoRowScrollProps {
  rowKey: string;
}

// Banner explaining competitor indication rows, shown above the first competitor row.
export const CompetitorIndicationsInfoRow: React.FC<CompetitorIndicationsInfoRowProps> = ({
  rowKey,
  monthGridTemplateColumns,
  registerMonthScroller,
  onMonthScroll,
}) => {
  const scrollerKey = `info-competitor-${rowKey}`;
  return (
    <div className="dom-pane-row dom-pane-row--info dom-pane-row--info-competitor">
      <div className="dom-pane-left dom-pane-left--info">
        <span className="dom-info-tag">COMPETITOR INDICATIONS</span>
        <span className="dom-info-text">
          Marketers set competitor prices. Entries are private and not shared.
        </span>
      </div>
      <div
        ref={registerMonthScroller(scrollerKey)}
        className="dom-pane-center-scroll dom-pane-center-scroll--info"
        onScroll={(event) => onMonthScroll(scrollerKey, event.currentTarget.scrollLeft)}
      >
        <div
          className="dom-pane-month-grid"
          style={{ gridTemplateColumns: monthGridTemplateColumns }}
        >
          <div className="dom-pane-info-center-cell" />
        </div>
      </div>
      <div className="dom-pane-right dom-pane-right--info" />
    </div>
  );
};
